module.exports = __webpack_public_path__ + "static/media/unboxing_spring_7.0347ce34.jpg";